module.exports = __webpack_public_path__ + "img/demand.27d873c9.27d873c9.png";